import { AvailableModel } from 'api/prediction-engine';

// LC2 models score at most this many actors and stars per film. Loads for an
// LC2 model come back already cut to these limits, and the predict endpoint
// rejects anything above them.
export const LC2_CAST_RULE_VERSION = 'lc_v2';
export const LC2_MAX_ACTORS = 10;
export const LC2_MAX_STARS = 3;

export const usesLc2CastRule = (model: AvailableModel | null): boolean =>
  model?.cast_rule_version === LC2_CAST_RULE_VERSION;
